import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";
import { DatosFacturacion } from "../../features/general/catalogos/items/clientes/edit/componentes/types";

const controller = rpcController("Cliente");
const crud = rpcCrudService<models.Cliente, models.ClienteDTO>(controller);

export interface DatosRepetidoCliente {
    idCliente?: number | null;
}

const otros = cacheResource({
    add: crud.add,
    delete: crud.delete,
    update: crud.update,
    get: crud.get,
    getMemo: crud.getMemo,

    /**Obtiene una lista de clientes */
    Query: async (filtroCliente: models.FiltroCliente): Promise<models.ClienteViewDTO[]> => await controller('Query', {}, filtroCliente),

    /**Obtiene un cliente view  */
    GetClienteView: async (idCliente: number): Promise<models.ClienteView> => await controller("GetClienteView", { idCliente }),

    /**Consulta las direcciones de un cliente */
    ConsultarDirecciones: async (idCliente: number): Promise<models.DireccionClienteDTO[]> => await controller("ConsultarDirecciones", { idCliente }),

    /**Consulta los contactos de una dirección de un cliente */
    ConsultarContactos: async (idDireccionCliente: number): Promise<models.ContactoClienteDTO[]> => await controller("ConsultarContactos", { idDireccionCliente }),
  
    /**Consulta un contacto (ContactoCliente) por el IdRegistro */
    ConsultarContactosClientePorIdRegistro: async (IdRegistro: number): Promise<models.ContactoClienteDTO> => await controller("ConsultarContactosClientePorIdRegistro", { IdRegistro }),

    /**Obtiene un cliente con el id de contacto  */
    GetClienteByIdContacto: async (idContacto: number): 
    Promise<models.Cliente> => await controller("GetClienteByIdContacto", { idContacto }),

    /**
 * Obtiene una dirección de un cliente
 * @param idDireccion Id de la direccion
 */
    GetDireccion: async (idDireccion: number): Promise<models.DireccionClienteDTO> => await controller("GetDireccion", { idDireccion }),

    /**
 * Agrega un nuevo cliente de documentación
 * @param cliente 
 */
    AddDocumentacion: async (cliente: models.NuevoClienteDocumentacion): Promise<models.ResultadoNuevoClienteDocumentacion> => await controller("AddDocumentacion", {}, cliente),


    /**Consulta el credito disponible de un cliente */
    CreditoDisponible: async (idCliente: number): Promise<number> => await controller("CreditoDisponible", { idCliente }),

    RepetidoIdentificacion: async (valor: string, campo: CampoRepetidoIdentificacion, datos: DatosRepetidoCliente): Promise<boolean> => await controller("Repetido" + campo, { ...datos, valor }),

    /**Obtener datos de facturación de un cliente */
    ObtenerDatosFacturaCliente: async (idCliente: number): Promise<models.DatosFacturaCliente> => await controller("ObtenerDatosFacturaCliente", { idCliente }),

    /**Consulta los datos de crédito de un cliente */
    ConsultarDatosCredito: async (idCliente: number): Promise<models.ClienteCreditoDto> => await controller("ConsultarDatosCredito", { idCliente }),

    /**Modifica los datos de facturación de un cliente */
    ModificarDatosFacturacion: async (idCliente: number, datos: DatosFacturacion): Promise<models.ClienteCreditoDto> => await controller("ModificarDatosFacturacion", { idCliente }, datos),

    /**Regresa la cantidad de clientes que tienen convenio */
    ObtenerCantidadClienteConvenio: async (): Promise<number> => await controller("ObtenerCantidadClienteConvenio"),

    ObtenerCantidadClientesRegistrados: async (): Promise<number> => await controller("ObtenerCantidadClientesRegistrados"),

}, {
        Query: true,
        GetClienteView: true,
        GetDireccion: true,
        CreditoDisponible: true,
        RepetidoIdentificacion: true,
        ObtenerDatosFacturaCliente: true,
        ConsultarContactos: true,
        ConsultarDirecciones: true,
        ConsultarDatosCredito: true,
    }, {
        AddDocumentacion: true,
        ModificarDatosFacturacion: true
    });


export const Cliente = bindResource({ ...otros });
const test: ResourceIdentificacionRepetido<DatosRepetidoCliente> = Cliente;


// WEBPACK FOOTER //
// ./app/resources/items/cliente.ts